import { useEffect, useState, useRef } from "react";
import SimpleButton from '../common/SimpleButton/SimpleButton'
import closeImg from "../../assets/images/btn_close.webp"
import imgClaimBtn from "../../assets/images/btn_yellow.webp"
import imgMoo from "../../assets/images/icon_moo.webp"
import imgCheck from "../../assets/images/check.webp"
import imgMooRight from "../../assets/images/register_moo_right.webp"
import imgMooLeft from "../../assets/images/register_moo_left.webp"
import imgAirplane from "../../assets/images/airplane.webp"
import { Trans } from "@lingui/react/macro";
import { i18n } from "@lingui/core";
import s from './ModalRegister.module.css'
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";

interface ModalRegisterProps {
    closeModal: () => void;
}

const ModalRegister: React.FC<ModalRegisterProps> = ({ closeModal }) => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.game.user);
    const [inputValue, setInputValue] = useState(user.airdrop_address);
    const [isAnimating, setIsAnimating] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const hasSubmittedAddress = Boolean(user.airdrop_address && user.airdrop_address.trim() !== "");

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // console.log(e.target.value)
        setInputValue(e.target.value);
    };

    const handleSubmit = () => {
        const trimmedValue = inputValue.trim();

        if (trimmedValue) {
            dispatch({ type: 'game/updateAddress', payload: trimmedValue });
            // setInputValue(""); ???
        }
    };

    useEffect(() => {
        setIsAnimating(true);
        // document.body.style.overflow = "hidden";

        const handleResize = () => {
            if (containerRef.current && inputRef.current) {
                if (window.innerHeight < 500) {
                    const inputRect = inputRef.current.getBoundingClientRect();
                    const offset = inputRect.top - window.innerHeight / 2 + inputRect.height / 2;
                    containerRef.current.style.transform = `translateY(${-offset}px)`;
                } else {
                    containerRef.current.style.transform = "translateY(0)";
                }
            }
        };

        window.addEventListener("resize", handleResize);

        return () => {
            setIsAnimating(false);
            window.removeEventListener("resize", handleResize);
            // document.body.style.overflow = "";
            if (containerRef.current) {
                containerRef.current.style.transform = "translateY(0)";
            }
        };
    }, []);

    // const innerWidth = window.innerWidth;
    // const innerHeight = window.innerHeight;
    // const dpr = window.devicePixelRatio || 1;

    return (
        <div className={s.containerWrapper} ref={containerRef}>
            <SimpleButton imageUrl={closeImg} width={12} onClick={() => {
                setIsAnimating(false);
                closeModal();
            }} className={s.closePosition} />
            <img className={`${s.imgAirplane} ${isAnimating ? s.animateAirplane : ""}`} src={imgAirplane} alt="airplane" />

            <div className={s.container}>
                <img className={s.imgMooRight} src={imgMooRight} alt="moo" />
                <img className={s.imgMooLeft} src={imgMooLeft} alt="moo" />

                <div className={s.containerContent}>
                    <p className={s.text}><Trans>REGISTER YOUR ETH ADDRESS</Trans> <span className={s.spanColor}><Trans>FOR AIRDROP</Trans></span></p>

                    <div className={s.inputWrapper}>
                        <input
                            ref={inputRef}
                            className={s.input}
                            type="text"
                            value={inputValue}
                            onChange={handleChange}
                            placeholder={i18n._("paste your ERC20 address")}
                        />
                        {hasSubmittedAddress && <img className={s.imgCheck} src={imgCheck} alt='check' />}
                    </div>

                    <SimpleButton className={s.button} onClick={handleSubmit} imageUrl={imgClaimBtn}>
                        <img className={s.imgMoo} src={imgMoo} alt="ticket" />
                        <p className={s.buttonText}><Trans>Register</Trans></p>
                    </SimpleButton>

                    <div className={s.textNoteBox}>
                        <p className={s.textNote}>(!) <Trans>USE ERC-20 ADDRESSES WITH WEB3 WALLETS ONLY (METAMASK/TRUST WALLET, ETC.). NO CEX ADDRESSES!</Trans></p>
                        {/*<p className={s.textNote}>{`${innerWidth}x${innerHeight}, ${dpr}`}</p>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalRegister